import React, { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function DynamicDetailTable({ data, grid, AddBtn }) {

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        setTableData(data);
    }, [data]);

    const increaseQty = (rowIndex) => {
        const updated = [...tableData];

        const qty = updated[rowIndex].quantity + 1;
        const price = Number(updated[rowIndex].price);

        updated[rowIndex].quantity = qty;
        updated[rowIndex].total = price * qty;

        setTableData(updated);
    };

    const decreaseQty = (rowIndex) => {
        const updated = [...tableData];

        if (updated[rowIndex].quantity > 1) {
            const qty = updated[rowIndex].quantity - 1;
            const price = Number(updated[rowIndex].price);

            updated[rowIndex].quantity = qty;
            updated[rowIndex].total = price * qty;

            setTableData(updated);
        }
    };

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }}>

                {/* Header */}
                <TableHead style={{ backgroundColor: "#DEEDF5" }}>
                    <TableRow>
                        {grid.map((col, index) => (
                            <TableCell
                                key={index}
                                align="center"
                                style={{ padding: "10px 0" }}
                            >
                                {col.displayName}
                            </TableCell>
                        ))}

                        {AddBtn && (
                            <TableCell align="center" style={{ padding: "10px 0" }}>
                                Add More Products
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>

                {/* Body */}
                <TableBody>
                    {tableData.map((row, rowIndex) => (
                        <TableRow key={rowIndex} className="text-[#14181FEB]">

                            {grid.map((col, colIndex) => (
                                <TableCell
                                    key={colIndex}
                                    align="center"
                                    style={{ padding: 0 }}
                                >

                                    {/* Image */}
                                    {col.type === "img" ? (
                                        <div className="w-full flex justify-center">
                                            <img
                                                src={row[col.keyName]}
                                                alt=""
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>

                                    ) : col.type === "quantity" ? (

                                        <div className="flex justify-center items-center">
                                            <div className="border flex justify-center items-center gap-2 rounded-2xl">

                                                <button
                                                    onClick={() => decreaseQty(rowIndex)}
                                                    className="text-xl w-8 h-8 bg-[#F2F2F2] rounded-l-2xl"
                                                >
                                                    -
                                                </button>

                                                <p className="bg-white px-2">
                                                    {row.quantity}
                                                </p>

                                                <button
                                                    onClick={() => increaseQty(rowIndex)}
                                                    className="text-xl w-8 h-8 bg-[#F2F2F2] rounded-r-2xl"
                                                >
                                                    +
                                                </button>

                                            </div>
                                        </div>

                                    ) : col.type === "amount" ? (

                                        <p className="w-full">
                                            {row[col.keyName]}
                                            <span className="text-[#14181FA3] text-[10px] ml-1">
                                                AED
                                            </span>
                                        </p>

                                    ) : col.type === "Description" ? (

                                        <p className="w-full">
                                            {row[col.keyName]}
                                            <span className="text-[#008FFB] underline text-[10px] ml-1 cursor-pointer">
                                                Learn more
                                            </span>
                                        </p>

                                    ) : (

                                        <p className="w-full">{row[col.keyName]}</p>

                                    )}

                                </TableCell>
                            ))}

                            {AddBtn && (
                                <TableCell align="center" style={{ padding: 0 }}>
                                    <button className="px-4 py-1 bg-[#21446F] rounded-md text-[14px] text-white">
                                        Add
                                    </button>
                                </TableCell>
                            )}

                        </TableRow>
                    ))}
                </TableBody>

            </Table>
        </TableContainer>
    );
}